export const PROFILE = 'PROFILE';
export const IS_MANANGER = "IS_MANANGER";
export const IS_DRIVER = "IS_DRIVER";
export const IS_ADMIN = "IS_ADMIN";
export const PRE_CHECK = 'PRE_CHECK';
export const APP_BUSY = 'APP_BUSY';
export const TERMS_BUSY = 'TERMS_BUSY';
export const SIGNIN_ERROR = 'SIGNIN_ERROR';
export const NEED_AUTORIZATION = 'NEED_AUTORIZATION';
export const CARRIER_BLOCK = 'CARRIER_BLOCK';
